'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userClientDetails = require('./user-client-details.html');

var _userClientDetails2 = _interopRequireDefault(_userClientDetails);

var _userClientDetails3 = require('./user-client-details.controller');

var _userClientDetails4 = _interopRequireDefault(_userClientDetails3);

require('./user-client-details.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userClientDetailsComponent = {
  restrict: 'E',
  bindings: {
    user: '<'
  },
  template: _userClientDetails2.default,
  controller: _userClientDetails4.default,
  controllerAs: 'vm'
};

exports.default = userClientDetailsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-client-details/user-client-details.component.js
 **/